import { Box, Typography, Modal, Grid, Button } from "@mui/material";

import axiosLC, { BASE_URL, SEND_OTP_MESSAGE } from "services";
import { getAccessToken } from "lib/token";

interface Props {
  feId: string;
  userId: string;
  discarded: boolean;
  onClose: () => void;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  p: 5,
};

export const ModalSuccess = (props: Props) => {
  const { feId, userId, discarded, onClose } = props;

  const onButtonClick = async () => {
    const token = await getAccessToken();
    try {
      const result = await axiosLC.post(
        SEND_OTP_MESSAGE,
        {
          channel: "SMS",
          financialEntityId: feId,
          userId: userId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { sessionId } = result.data;
      window.location.href = `${BASE_URL}/otp?feId=${feId}&userId=${userId}&origin=onboarding&sessionId=${sessionId}`;
    } catch (error) {
      console.log("[SEND_OTP_MESSAGE_FORM]", error);
    }
  };

  return (
    <div>
      <Modal open={true}>
        <Box sx={style}>
          <Grid
            container
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Grid
              item
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                p: 1,
                bgcolor: "#05a86a",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                display: "flex",
                justifyContent: "end",
              }}
            ></Grid>
            <Grid>
              <svg
                width="70"
                height="70"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="#05a86a"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="12" cy="12" r="9" />
                <path d="M9 12l2 2l4 -4" />
              </svg>
            </Grid>
            <Grid
              item
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
              }}
            >
              <Typography
                id="modal-modal-title"
                variant="h5"
                sx={{ fontWeight: "bold" }}
              >
                ¡Bien hecho!
              </Typography>

              {discarded ? (
                <Button
                  onClick={onClose}
                  variant="contained"
                  style={{
                    width: "200px",
                    height: "40px",
                    fontSize: "12px",
                    marginTop: "1rem",
                    backgroundColor: "#05a86a",
                  }}
                >
                  Aceptar
                </Button>
              ) : (
                <>
                  <Typography variant="h5" sx={{ textAlign: "center" }}>
                    Ahora autoriza la consulta a centrales de riesgo
                  </Typography>
                  <Button
                    onClick={onButtonClick}
                    variant="contained"
                    style={{
                      width: "200px",
                      height: "40px",
                      fontSize: "12px",
                      marginTop: "1rem",
                      backgroundColor: "#05a86a",
                    }}
                  >
                    Autorizar
                  </Button>
                </>
              )}
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};
